import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuccessModal = ({ isOpen, onClose, referenceNumber }) => {
  if (!isOpen) return null;

  const currentDate = new Date()?.toLocaleDateString('th-TH', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long'
  });

  const expectedResponseDate = new Date(Date.now() + 15 * 24 * 60 * 60 * 1000)?.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

  const handleCopyReference = () => {
    navigator.clipboard?.writeText(referenceNumber);
    // In a real app, you might show a toast notification here
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-200 p-4">
      <div className="bg-card rounded-lg border border-border shadow-government-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          {/* Success Icon */}
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-success rounded-full flex items-center justify-center">
              <Icon name="CheckCircle" size={32} color="white" />
            </div>
          </div>

          {/* Success Message */}
          <div className="text-center mb-6">
            <h2 className="text-xl font-semibold text-foreground mb-2">
              ส่งเรื่องร้องเรียนสำเร็จ
            </h2>
            <p className="text-muted-foreground">
              เจ้าหน้าที่จะดำเนินการตรวจสอบและติดต่อกลับ
            </p>
          </div>

          {/* Reference Number */}
          <div className="bg-muted/50 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <p className="text-sm text-muted-foreground mb-1">
                  หมายเลขอ้างอิง
                </p>
                <p className="font-mono text-lg font-semibold text-primary">
                  {referenceNumber}
                </p>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={handleCopyReference}
                iconName="Copy"
                iconPosition="left"
              >
                คัดลอก
              </Button>
            </div>
          </div>

          {/* Timeline Information */}
          <div className="space-y-4 mb-6">
            <div className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-success/20 rounded-md flex items-center justify-center flex-shrink-0">
                <Icon name="Calendar" size={16} className="text-success" />
              </div>
              <div className="flex-1">
                <p className="font-medium text-foreground text-sm">
                  วันที่ยื่นเรื่อง
                </p>
                <p className="text-sm text-muted-foreground">
                  {currentDate}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-warning/20 rounded-md flex items-center justify-center flex-shrink-0">
                <Icon name="Clock" size={16} className="text-warning" />
              </div>
              <div className="flex-1">
                <p className="font-medium text-foreground text-sm">
                  กำหนดการตอบกลับ
                </p>
                <p className="text-sm text-muted-foreground">
                  ภายในวันที่ {expectedResponseDate}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-primary/20 rounded-md flex items-center justify-center flex-shrink-0">
                <Icon name="Phone" size={16} className="text-primary" />
              </div>
              <div className="flex-1">
                <p className="font-medium text-foreground text-sm">
                  การติดตาม
                </p>
                <p className="text-sm text-muted-foreground">
                  โทร 02-123-4567 พร้อมหมายเลขอ้างอิง
                </p>
              </div>
            </div>
          </div>

          {/* Important Notes */}
          <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 mb-6">
            <div className="flex items-start space-x-3">
              <Icon name="Info" size={16} className="text-accent flex-shrink-0 mt-0.5" />
              <div className="flex-1">
                <p className="font-medium text-accent-foreground text-sm mb-2">
                  ข้อมูลสำคัญ
                </p>
                <ul className="text-sm text-muted-foreground space-y-1">
                  <li>• กรุณาเก็บหมายเลขอ้างอิงไว้สำหรับการติดตาม</li>
                  <li>• เจ้าหน้าที่จะติดต่อกลับตามหมายเลขที่ให้ไว้</li>
                  <li>• สามารถสอบถามความคืบหน้าได้ในวันทำการ</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              variant="default"
              onClick={onClose}
              iconName="Home"
              iconPosition="left"
              fullWidth
            >
              กลับสู่หน้าหลัก
            </Button>
            <Button
              variant="outline"
              onClick={() => window.print()}
              iconName="Printer"
              iconPosition="left"
              fullWidth
            >
              พิมพ์ใบรับ
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;